import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Document from "../../pages/DocumentsPage/Document";

const DocumentBlock = ({ description, files }) => {
  return (
    <div>
      {files !== null && (
        <>
          <h3 className="mt-5">Ke stažení</h3>
          <BlocksRenderer
            content={Array.isArray(description) ? description : []}
            blocks={{
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText}
                  className="blocks-renderer-img"
                />
              ),
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="blocks-renderer-ul">{children}</ul>
                ) : (
                  <ol className="blocks-renderer-ol">{children}</ol>
                ),
            }}
          ></BlocksRenderer>
          <div className="news-doc-container">
            {files.map((doc, idx) => (
              <div key={idx} className="news-doc">
                <Document name={doc.name} fileUrl={doc.file.url} />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default DocumentBlock;
